<template>
  <div
    class="video-hero-block -p-relative"
    ref="overlay"
    :class="{
      '-collapsed': !expand,
      '-expanded-full': expanded,
      '-expand': expand,
    }"
  >
    <transition name="fade">
      <div
        v-show="!expand"
        class="overlay-text"
        style="z-index: 10001; pointer-events: none"
      >
        <div class="grid p-t-0 p-b-0">
          <component
            v-if="model.Title"
            :is="h1Title ? 'h1' : 'h2'"
            class="font-responsive-xl g-md-6 p-b-9 m-b-0"
            :style="style"
            v-html="titleWidthStyles"
          />
          <div
            v-if="model.Lead"
            class="-lead g-md-6"
            :style="style"
            v-html="model.Lead"
          ></div>
        </div>
      </div>
    </transition>

    <div class="video-hero-block-nav">
      <div v-show="!this.expand" class="grid p-b-0 p-t-0">
        <div class="d-flex justify-content-center">
          <div class="-pointer-on">
            <div
              v-if="!model.NotExpandable && mediaType === 'video'"
              @click="expand = true"
              class="d-flex align-items-center flex-column -clickable"
            >
            <button class="d-flex align-items-center flex-column">
              <Chevron
                :direction="'up'"
                :color="fontColor || Globals.colors.white"
              />
              <div>
                {{ insertString("Global", "ViewFilm") }}
              </div>
            </button>
            </div>
            <RadioSlider
              v-if="!model.NoToggler"
              :style="mounted && toggleValue ? 'opacity:1' : 'opacity:0'"
              class="toggler m-t-12 m-t-md-18"
              :modelValue="toggleValue"
              :options="toggleOptions"
              :large="$mqAliases.desktop"
              :backgroundColor="Globals.colors.grayLight"
              :sliderColor="Globals.colors.white"
              :fontColor="Globals.colors.black"
              @clicked="gotoView($event)"
            />
          </div>
        </div>
      </div>

      <button
        v-show="expanded"
        class="video-hero-block-close -pointer-on"
        @click="expand = false"
      >
        <div class="-pointer-on -clickable">
          <SvgComponent
            :icon="{ name: 'close', color: Globals.colors.white }"
          />
        </div>
      </button>
    </div>
    <!-- Adds gradient to the whole banner. -->
    <transition name="fade">
      <div
        v-show="showOverlay && !expand"
        class="overlay-image"
        :class="overlayDir"
      />
    </transition>
    <VideoStream
      v-if="mediaType === 'video' && media"
      class="video-hero-stream"
      :class="{ '-animating': animating }"
      :modelValue="video"
      :preview="!expand"
      :previewHeight="previewHeight"
      :settings="videoSettings"
      :fillHeight="$mqAliases.sm || $mqAliases.xs"
      :orientation="isPortrait ? 'portrait' : 'landscape'"
      @on-seeked="animating = false"
      @on-duration="trackDuration"
    />
    <v-lazy-image
      v-else-if="media && media[0]"
      class="w-100"
      :src="imageObj.src"
      :srcset="imageObj.srcset"
      :sizes="imageObj.sizes"
      alt=""
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import TinyColor from 'tinycolor2';
import ScrollLock from '@/Scripts/lib/mixins/scrollLock.js';
import VideoStream from '@/Scripts/components/media/VideoStream/VideoStream.vue';
import SvgComponent from '@/Scripts/components/shared/svg/Svg.vue';
import Chevron from '@/Scripts/components/shared/svg/Chevron/Chevron.vue';
import RadioSlider from '@/Scripts/components/form/RadioSlider/RadioSlider.vue';
import VLazyImage from 'v-lazy-image';
import siteInfo from '@/Scripts/lib/helper/siteInfo.js';
import { gaCustomEvents } from '@/Scripts/lib/tracking/googleAnalyticsTrackerV2';
import ImageCollectorHelper from '@/Scripts/lib/helper/imageCollectorHelper.js';

export default {
  name: 'VideoHeroBlock',
  mixins: [
    ScrollLock,
    siteInfo
  ],
  components: {
    VideoStream,
    SvgComponent,
    Chevron,
    RadioSlider,
    VLazyImage
  },
  props: {
    model: Object,
    index: Number,
    category: String,
    h1Title: Boolean
  },
  data () {
    return {
      expand: false,
      expanded: false,
      animating: false,
      toggleValue: null,

      overlayClasses: ['-top', '-top', '-bottom', '-left', '-right'],
      mounted: false,
      transition: 1000,
      transitionMax: 1000,
      isPortrait: false

    };
  },
  watch: {

    expand (val) {
      this.animating = true;
      const link = document.getElementById('intercom-container');
      if (val) {
        // expand
        this.$store.dispatch('appContext/setFadeHeader', true);
        if (link) {
          link.style.display = 'none'; // hide intercom
        }
        gaCustomEvents('VideoHeroTop', 'clicked', 'video');
        window.scrollTo(0, 0);
        setTimeout(() => {
          this.lockScroll();
          this.expanded = true;
        }, this.transition);
      } else {
        // collapse
        gaCustomEvents('VideoHeroTop', 'clicked', 'closevideo');
        if (link) {
          link.style.display = 'block'; // show intercom
        }
        this.freeScroll();
        this.expanded = false;
        this.$store.dispatch('appContext/setFadeHeader', false);
        window.scrollTo(0, 0);
      }
      // case if seeking event are failing
      setTimeout(() => {
        this.animating = false;
      }, this.transitionMax);
    }
  },
  computed: {
    ...mapState({
      blackTheme: state => state.appContext.blackTheme,
      staticHeader: state => state.appContext.staticHeader
    }),
    intercomExist () {
      return window.Intercom;
    },
    videoSettings () {
      return {
        mouseTrigger: false,
        preview: true,
        previewLoop: !this.model.NotExpandable,
        previewPoster: !this.$mqAliases.desktop && this.model.ShowPosterOnMobile,
        loopStart: this.model.StartPreviewLoop || 5,
        loopEnd: this.model.EndPreviewLoop || 10
      };
    },
    previewHeight () {
      if (this.$mqAliases.sm || this.$mqAliases.xs) {
        return ((document.documentElement.clientWidth || document.body.clientWidth) * 1.25) + 22;
      }
      return ((document.documentElement.clientWidth || document.body.clientWidth) * 0.33) + 22;
    },
    // NAVIGATION
    toggleOptions () {
      return [{
        label: this.model.ContentPageLinkText || '',
        value: 'contentpage'
      },
      {
        label: this.model.ProductPageLinkText || '',
        value: 'productpage'
      }];
    },
    // MEDIA
    media () {
      if (this.model && this.model.ImageCollectorMaxBlock && this.model.ImageCollectorMaxBlock.Media && this.model.ImageCollectorMaxBlock.Media[0]) {
        return this.model.ImageCollectorMaxBlock.Media;
      }
      return null;
    },
    mediaType () {
      if (!this.media || !this.media[0]) {
        return null;
      }
      return this.media[0].Extension === 'mp4' ? 'video' : 'image';
    },
    responsiveMedia () {
      const data = { desktop: [], mobile: [] };
      if (!this.media) {
        return data;
      }
      const media = [...this.media];
      for (let i = 0; i < media.length; i++) {
        const item = media[i];
        let foundPair = false;
        if (item.PairingId) {
          const pair = media.splice(media.findIndex(obj => obj.PairingId === item.PairingId && obj.Id !== item.Id && !obj.isPaired), 1);
          if (pair && pair.length) {
            const itemAsDekstop = item.Width / item.Height > pair[0].Width / pair[0].Height;
            data.desktop.push(itemAsDekstop ? item : pair[0]);
            data.mobile.push(itemAsDekstop ? pair[0] : item);
            foundPair = true;
          }
        }
        if (!foundPair) {
          data.desktop.push(item);
          data.mobile.push(item);
        }
      }
      return data;
    },
    video () {
      if (this.$mqAliases.sm || this.$mqAliases.xs) {
        return this.responsiveMedia.mobile[0];
      }
      return this.responsiveMedia.desktop[0];
    },
    proportion () {
      return this.video.Width / this.video.Height;
    },
    imageObj () {
      if (this.model && this.model.ImageCollectorMaxBlock) {
        const obj = this.model.ImageCollectorMaxBlock.Media ? this.model.ImageCollectorMaxBlock.Media[0] : {};
        return ImageCollectorHelper.buildMediaObject(obj, this.$mqAliases.desktop ? 16 / 9 : 4 / 5);
      }
      return null;
    },

    // STYLING
    titleWidthStyles () {
      if (this.model.Subtitle) {
        const devider = '<br />';
        return `<span class='-bold'>${this.model.Title}</span>${devider}<span class='-thin'>${this.model.Subtitle}</span>`;
      }
      return this.model.Title;
    },
    backgroundColor () {
      return this.model.ColorOptions.GradientTo || this.model.ColorOptions.BackgroundColor || (this.blackTheme ? this.Globals.colors.black : this.Globals.colors.white) || this.Globals.colors.white;
    },
    fontColor () {
      if ((this.$mqAliases.xs || this.$mqAliases.sm) && this.model.MobilePlacement === 0) {
        return TinyColor.mostReadable(this.backgroundColor, [this.Globals.colors.white, this.Globals.colors.black]).toHexString();
      }
      return this.model.ColorOptions.FontColor;
    },
    style () {
      return {
        color: `${this.fontColor || '#fcfcfc'}`
      };
    },
    // Gradient overlay
    showOverlay () {
      return true;
    },
    overlayDir () {
      if (!this.model) {
        return null;
      }
      return this.overlayClasses[this.model.OverlayDirection];
    },
    collection () {
      const segments = new URL(window.location.href).pathname.split('/');
      const last = segments.pop() || segments.pop(); // Handle potential trailing slash
      return last;
    }
  },
  methods: {
    trackDuration (eventLabel) {
      if (this.expanded) {
        gaCustomEvents('VideoHeroTop', eventLabel, 'video');
      }
    },
    gotoView (val) {
      if (val !== this.toggleValue) {
        setTimeout(() => {
          if (val === 'contentpage') {
            gaCustomEvents('VideoHeroTop', 'clicked', 'contentpage');
            window.location.href = this.getLink('Events') + `page?pageId=${this.model.ViewMoreDestinationId}`; // goto contentpage
          } else if (val === 'productpage') {
            gaCustomEvents('VideoHeroTop', 'clicked', 'productpage');
            window.location.href = this.model.ViewMoreDestination; // goto product page
          }
        }, 330);
      }
    },
    doExpand () {
      this.expand = !this.expand;
    },
    getOrientation () {
      this.isPortrait = window.innerHeight >=
        (document.documentElement.clientWidth || document.body.clientWidth);
    }

  },
  mounted () {
    this.toggleValue = this.category ? 'contentpage' : 'productpage';

    this.getOrientation();
    window.addEventListener('resize', () => {
      this.getOrientation();
    });
    document.body.addEventListener('keyup', e => {
      if (e.key === 'Escape') {
        if (this.expanded) {
          this.expand = false;
        }
      }
    });
    this.$nextTick(() => {
      setTimeout(() => {
        gaCustomEvents('VideoHeroTop', 'viewed', this.toggleValue);
        this.mounted = true;
      }, 660);
    });
  }
};
</script>
<style lang="scss" src="@/scss/components/components.overlay-image.scss"></style>
<style lang="scss">
@import "@/scss/defaults.scss";
.video-hero-block {
  display: flex;
  align-items: center;
  overflow: hidden;
  transition: height 0.33s;
  background-color: #000;
  // height: 450px;
  // @include media-breakpoint-up(md) {
  //   height: 450px;
  // }

  height: 125vw;
  @include media-breakpoint-up(md) {
    height: 33vw;
  }
  .video-hero-stream {
    opacity: 1;
    transition: opacity 0.33s ease-out;
    &.-animating {
      transition: none;
      opacity: 0;
    }
  }
  .overlay-image {
    z-index: 5;
  }

  @include media-breakpoint-down(sm) {
    h1, h2 {
      @include font-size(larger, xs);
      padding-bottom: 6px !important;
    }
  }

  .-lead,
  .-lead p {
    @include font-size(body);
    @include media-breakpoint-up(md) {
      @include font-size(larger, md);
    }
    @include media-breakpoint-up(lg) {
      @include font-size(xl, md);
    }
  }
  .toggler {
    transition: opacity 0.33s;
  }
  .overlay-text {
    width: 100%;
    pointer-events: all;
    position: absolute;
    top: 18px;
    @include media-breakpoint-up(md) {
      top: 54px;
    }
  }
  .video-hero-block-nav {
    width: 100%;
    position: absolute;
    top: 18px;
    z-index: 10;
    .video-hero-block-close {
      position: absolute;
      right: 18px;
      z-index: 500010;
    }
    button {
      background: none;
      border: none;
      color: $secondary;
    }
  }
  &.-collapsed {
    .video-hero-block-nav {
      bottom: 12px;
      @include media-breakpoint-up(md) {
        bottom: 24px;
      }
      top: unset;
    }
  }
  &.-expand {
    height: 100vh;
  }
  &.-expanded-full {
    position: fixed;
    top: 0;
    z-index: 50000;
    height: 100vh;
    width: 100%;
    background-color: #000;
    .video-hero-block-nav {
      z-index: 500010;
    }
  }
}
</style>
